import { ViewmodelSchema } from '@bingads-webui/viewmodel-schema';
import { createBackboneModel } from './factory';

/**
 * Viewmodel schema, generated from schema file. It provides auto generated
 * default value, validation rules and conversions
 * @param {JsonSchema} schema - an object which contains property 'properties',
 * @param {I18n} i18n - provide callback getString to get message
 * @param {Array} fields - list of fields to read from schema
 * @param {Object} model - raw model with default values
 * @param {Object} override - optional override object that changes auto-generated fields
 * @param {Object} baseClass - optional baseClass other than default backbone model
 * @returns {Object} - return default values merged from both inputs
 */

export function BackboneSchema(schema, i18n, fields, model = null, override = null) {
  const vmSchema = new ViewmodelSchema(schema, i18n, fields, override);
  const odataType = fields.indexOf('@odata.type') >= 0 ? `#Model.${schema.name}` : null;

  return createBackboneModel(vmSchema, schema, model, odataType);
}
